import React from "react";
import { useNavigate } from "react-router-dom";
import { FaLayerGroup, FaPaintBrush } from "react-icons/fa";
import Hero from "../../components/hero/hero.component";
import Faq from "../../components/faq/faq.component";
import UIimage from "../../assets/UX design..svg";
import user1 from "../../assets/img/one.png";
import user2 from "../../assets/img/two.png";
import Shake from "react-reveal/Shake";
import Jump from "react-reveal/Jump";
import Features from "../../components/ui-ux/FeatureCard";
import user3 from "../../assets/img/three.png";
import PortfolioSection from "../../components/ui-ux/PortfolioSection";
import TestimonySlide from "../../components/testimony-slide/testimony-slide.component";
import AppButton from "../../components/app-button/app-button.component";
import { Zoom } from "react-reveal";
import Standout from "../../components/standout/standout.component";
import Footer from "../../components/footer/footer.component";

const UIDesign = () => {
  const navigate = useNavigate();
  const features = [
    {
      id: 1,
      title: "UI/UX Design",
      description:
        "Create intuitive, engaging, and user-friendly interfaces that deliver seamless digital experiences.",
      icon: FaPaintBrush,
    },
    {
      id: 2,
      title: "Product Design",
      description:
        "Turn ideas into meaningful digital products through research, prototyping, and thoughtful design.",
      icon: FaLayerGroup,
    },
  ];

  const enrollMessage = encodeURIComponent(
    `Hello, I'm interested in your IoT /Robotics Training Program at Cephas ICT Hub. 
     
      I'd like to know more about the course, including the duration, training schedule, fees, learning format(online or onsite), and how to register.
      
      I look forward to your response. Thank you!
      `,
  );

  const goToTestimony = () => {
    navigate("/testimony");
  };

  //   const contactMessage = encodeURIComponent(
  //     "Hello, I'm interested in your  IoT /Robotics  Training Program at Cephas ICT Hub. I'd like to know more about the course.",
  //   );
  return (
    <div>
      <div>
        <Hero
          pretitle="IOT|Robotics Training Program"
          title={
            <>
              Become a
              <br />
              <span className="text-[#030A49]"> Product Designer</span>
              <br />
              Who Can Build Real Digital Products.
            </>
          }
          description={
            "Master UI/UX design, prototyping, and product strategy in a comprehensive program designed to take you from fundamentals to a hired professional."
          }
          price="₦480,000"
          duration="3 Months"
          primaryLink={{
            href: `https://wa.me/2348141335945?text=${enrollMessage}`,
            text: "Start Learning",
          }}
          secondaryLink={{
            // href: `https://wa.me/2348141335945?text=${contactMessage}`,
            text: "View Syllabus",
          }}
          users={[user1, user2, user3]}
          imageSrc={UIimage}
          features={features}
        />
      </div>

      <Features />

      <PortfolioSection />

      <section className="mb-20 py-10 relative">
        <div className="container mx-auto px-8 md:px-0">
          <Shake>
            <p className="capitalize text-[#000D83] text-4xl font-medium text-center">
              what makes us <span className="text-[#EFA632]">stand out</span>
            </p>
          </Shake>
          <Standout />
        </div>
        <div className="bg-[#3EC4FF] opacity-[.08] -z-10 absolute inset-0"></div>
      </section>

      <section className="container mx-auto px-8 md:px-0 mb-20">
        <div className="grid md:grid-cols-2 gap-8">
          <div className="self-center">
            <Zoom>
              <p className="text-[#000D83] font-bold text-4xl md:text-4xl capitalize">
                hear what our{" "}
                <span className="text-[#EFA632]">students have to say</span>
              </p>
              <p className="text-lg mt-8">
                Take a dive into the reviews of what our current students and
                alumni have to say about their experience at Cephas Digital
              </p>
            </Zoom>
            <div className="mt-8">
              <Jump>
                <AppButton
                  children="Read More"
                  buttonType="primary"
                  handleButton={goToTestimony}
                />
              </Jump>
            </div>
          </div>
          <div className="">
            <TestimonySlide />
          </div>
        </div>
      </section>

      <div>
        <Faq />
      </div>

      <div>
        <Footer />
      </div>
    </div>
  );
};

export default UIDesign;
